import {
  Backdrop,
  Box,
  CircularProgress,
  Divider,
  Grid2,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Layout from "../../layouts/Layout";
import { useSelector } from "react-redux";
import axiosInstance from "../../utils/config/config";
import CountCards from "../../Components/Admin/CountCards";
import UsersList from "../../Components/Admin/UsersList";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../Components/Common/CustomSnackbar";
import SingleVideo from "../../Components/HomePage/SingleVideo";
import ReportedContent from "../../Components/Admin/ReportedContent";

const AdminDashboard = () => {
  const { userData } = useSelector((state) => state.user);
  const [selectedTab, setSelectedTab] = useState(null);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const videoRefs = useRef([]);
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const [creators, setCreators] = useState([]);
  const [posts, setPosts] = useState([]);
  const [reports, setReports] = useState([]);
  const [success, setSuccess] = useState({
    open: false,
    message: "",
  });
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const [allData, setAllData] = useState({
    users: 0,
    creators: 0,
    "Total Posts": 0,
    Reports: 0,
  });

  const handlePlayPause = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });

    if (currentPlayingIndex === index) {
      videoRefs.current[index].pause();
      setCurrentPlayingIndex(null);
    } else {
      videoRefs.current[index].play();
      setCurrentPlayingIndex(index);
    }
  };

  const fetchAdminForData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/user/getDataForAdmin");

      setAllData(response.data.counts);
      setSelectedTab("Users");
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const fetchTabData = async () => {
    try {
      setLoading(true);
      const resp = await axiosInstance.get(`/user/tabData/${selectedTab}`);

      if (selectedTab === "Users") {
        setUsers(resp.data.resp);
      }

      if (selectedTab === "Creators") {
        setCreators(resp.data.resp);
      }
      if (selectedTab === "Total Posts") {
        setPosts(resp.data.resp);
      }
      if (selectedTab === "Reports") {
        setReports(resp.data.resp);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    if (selectedTab) {
      fetchTabData();
    }
  }, [selectedTab]);

  useEffect(() => {
    if (userData.role === "admin") {
      fetchAdminForData();
    }
  }, []);

  const markPostInactive = async (id) => {
    try {
      const resp = await axiosInstance.put(`/post/markPostInactive/${id}`);

      if (resp) {
        setSuccess({ open: true, message: "Success updating post status." });
        fetchTabData();
      }
    } catch (err) {
      console.log(err);
      setErrorState({ error: true, message: "Error updating post status." });
    }
  };
  const markPostActive = async (id) => {
    try {
      const resp = await axiosInstance.put(`/post/markPostActive/${id}`);

      if (resp) {
        setSuccess({ open: true, message: "Success updating post status." });
        fetchTabData();
      }
    } catch (err) {
      console.log(err);
      setErrorState({ error: true, message: "Error updating post status." });
    }
  };

  return (
    <Layout>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success.open}
        handleSnackbarClose={() => setSuccess({ open: false, message: "" })}
        text={success.message}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CountCards
        data={allData}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />

      <Divider />

      {selectedTab === "Users" && (
        <UsersList
          users={users}
          setErrorState={setErrorState}
          setSuccess={setSuccess}
          fetchTabData={fetchTabData}
        />
      )}
      {selectedTab === "Creators" && (
        <UsersList
          users={creators}
          setErrorState={setErrorState}
          setSuccess={setSuccess}
          fetchTabData={fetchTabData}
        />
      )}
      {selectedTab === "Reports" && (
        <ReportedContent
          reports={reports}
          markPostActive={markPostActive}
          markPostInactive={markPostInactive}
        />
      )}
      {selectedTab === "Total Posts" && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 2,
          }}
        >
          {posts &&
            posts?.map((item, index) => (
              <SingleVideo
                key={index}
                item={item}
                videoRef={(ref) => (videoRefs.current[index] = ref)}
                onPlayPause={() => handlePlayPause(index)}
                isPlaying={currentPlayingIndex === index}
                paid={true}
                markPostActive={markPostActive}
                markPostInactive={markPostInactive}
              />
            ))}
        </Box>
      )}
    </Layout>
  );
};

export default AdminDashboard;
